import { useEffect, useState } from 'react';

export function useHasWindow() {
  const [isWindow, setIsWindow] = useState(false);

  useEffect(() => {
    setIsWindow(true);

    return () => setIsWindow(false);
  }, []);

  return isWindow;
}
